export default __webpack_public_path__ + "static/media/linen.3bf3f387.png";